import {
  createFrontendModule,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { Settings } from 'lucide-react';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';

// Create a custom user-settings navigation item with better icon
// IMPORTANT: No 'name' property to ensure ID matches the original 'nav-item:user-settings'
const customUserSettingsNavItem = NavItemBlueprint.make({
  params: {
    title: 'Settings',
    icon: Settings as IconComponent,
    routeRef: userSettingsPlugin.routes.root,
  },
});

// Apply override to replace the factory function
const customUserSettingsNavExtension = customUserSettingsNavItem.override({
  factory: (originalFactory, context) => {
    return originalFactory(context);
  },
});

// Create a module that contains our custom user-settings configurations
// Using 'user-settings' as pluginId since we're overriding user-settings plugin
export const customUserSettingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [
    customUserSettingsNavExtension, // Add the custom nav item with override
    // Add more user-settings customizations here later
  ],
});